import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaForm from './VaForm.vue'

export const VaForm = withConfigTransport(_VaForm)
